import { RedirectLocation } from '../../../state/actions';

export const getReturnHomeLocation = (
  productReference: string
): RedirectLocation => ({
  pathname: `/${productReference}/home`,
});
